import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NavigationEnd, Router} from '@angular/router';
import {Product} from '@app/core/product/domain/dtos/product';
import {routesNames} from "@app/app-routing.module";

@Component({
  selector: 'app-not-enough-stock-modal',
  templateUrl: './no-stock-modal.component.html',
  styleUrls: ['./no-stock-modal.component.scss']
})
export class NoStockModalComponent implements OnInit {

  products: Product[] = [];
  firstThreeProductsCodes: string[] = [];

  routesNames = routesNames;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<NoStockModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      products: Product[]
    }
  ) {
    this.router.events.subscribe({
      next: event => {
        // Force closing the modal when redirect to another page
        if (event instanceof NavigationEnd) {
          this.closeModal();
        }
      }
    })
  }

  ngOnInit(): void {
    if (this.data) {
      this.products = this.data.products;
      this.firstThreeProductsCodes = this.products.slice(0, 3).map(product => product.code) ?? [];
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}
